import { Router } from "aurelia-router";
import { autoinject, observable } from "aurelia-framework";
import { User } from "oidc-client";
import { OpenIdConnect, OpenIdConnectRoles } from "aurelia-open-id-connect";
import { TenantService } from "../services/tenant-service";
import { HttpClient } from "aurelia-fetch-client";
import { AureliaApplicationSettings } from "../models/aurelia-application-settings";
import { AdminApi } from "../services/admin-api";
import { applicationLogger } from "../logging/logger";

@autoinject
export class Navmenu {

    private user: User;


	constructor(private router: Router, private openIdConnect: OpenIdConnect, private tenantService: TenantService, private appSettings: AureliaApplicationSettings, private adminApi: AdminApi) { }

    get roles() {
        if (this.user) {
            return this.user.profile.role;
        }
        return [];
    }

    get userName() {
        if (this.user) {
            return this.user.profile.name;
        }
        return "";
    }

    attached() {
        this.openIdConnect.observeUser((user: User) => this.onUserChanged(user));
    }

    get isStaging() : boolean {
        return window.location.origin.startsWith("https://staging");
    }

    private onUserChanged(user: User) {
        this.user = user;
    }


    removeCookies() {

        try {
            var res = document.cookie;
            var multiple = res.split(";");
            for (var i = 0; i < multiple.length; i++) {
                var key = multiple[i].split("=");
                document.cookie = key[0] + " =; expires = Thu, 01 Jan 1970 00:00:00 UTC";
            }
        }
        catch (ex) {
            //swallow for now.
        }
     
    }

    private async logout() {
        var result = await this.adminApi.apiLogout();
        if (result && result.success) {
            applicationLogger.error(result.message);

            this.removeCookies();

            localStorage.clear();

            //await this.openIdConnect.logout();
            //this.router.navigateToRoute("unauthorized");
            this.router.navigateToRoute("redirect-to-authority-login");
        }

       


     
    }
}
